import React from 'react';
import { Name, InfoBox } from './styles';

interface BrandInfoBoxProps {
  providerBrandName: string;
}
export const BrandInfoBox = ({ providerBrandName }: BrandInfoBoxProps) => {
  return (
    <InfoBox className="listing-carousel-card-details">
      <Name>{providerBrandName}</Name>
    </InfoBox>
  );
};
